const initialState = {
    customerId: undefined,
    mode: undefined
}

function customer(state = initialState, action) {
    switch (action.type) {

        case 'SET_CUSTOMER_ID': {
            const { id } = action
            return { ...state, customerId: id }
        }
        case 'CUSTOMER_ID_CLEARED': {
            return { ...state, customerId: undefined }
        }
        case 'SET_CUSTOMER_FORM_MODE': {
            const { mode } = action
            return { ...state, mode }
        }
        case 'CUSTOMER_FORM_MODE_CLEARED': {
            return { ...state, mode: undefined }
        }
        default:
            return state
    }
}

export default customer